"use client";

import { useEffect, useState } from "react";
import ActionButton from "../molecules/ActionButton";
import CallPopup from "@/app/components/callBack";
import { useCallCheck } from "@/app/hooks/useCallCheck";
import { resolveLegacyLink } from "@/app/utils/linkUtils";
import { buildProspectLink } from "@/app/utils/prospectLink";
import { usePathname } from "next/navigation";

export default function ActionSidebar() {
  const [showPopup, setShowPopup] = useState(false);
  const { isAllowed } = useCallCheck();
  const pathname = usePathname();

  const [commanderHref, setCommanderHref] = useState<string>(
    resolveLegacyLink("/parcours-prospects", "clients")
  );

  const [hasContactAnchor, setHasContactAnchor] = useState(false);

  useEffect(() => {
    const link =
      buildProspectLink() || resolveLegacyLink("/parcours-prospects", "clients");
    setCommanderHref(link);
  }, []);

  useEffect(() => {
    const checkContactAnchor = () => {
      const contactElement = document.getElementById("contact");
      setHasContactAnchor(!!contactElement);
    };

    const raf = requestAnimationFrame(checkContactAnchor);

    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return (
    <>
      {/* Version desktop */}
      <aside
        aria-label="Actions rapides"
        className="fixed right-3 md:right-2 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col items-center gap-4"
      >
        {isAllowed && (
          <ActionButton
            iconName="https://site-lms.fra1.digitaloceanspaces.com/phone_d3bb0f75b3.svg"
            label="Appel immédiat"
            onclick={() => setShowPopup(true)}
          />
        )}

        {hasContactAnchor && (
          <ActionButton
            iconName="https://site-lms.fra1.digitaloceanspaces.com/Mail_46bac8fc9f.svg"
            label="Être contacté"
            href="#contact"
          />
        )}

        <ActionButton
          iconName="https://site-lms.fra1.digitaloceanspaces.com/Mall_5f93dab076.svg"
          label="Commander"
          target="_blank"
          href={commanderHref}
        />
      </aside>

      {/* Version mobile */}
      <div
        aria-label="Actions rapides"
        className="fixed bottom-0 inset-x-0 z-50 lg:hidden bg-secondary text-white pb-4"
      >
        <div className="flex justify-center items-stretch">
          {isAllowed && (
            <ActionButton
              iconName="https://site-lms.fra1.digitaloceanspaces.com/phone_d3bb0f75b3.svg"
              label="Appel immédiat"
              className="mt-[-20px]"
              onclick={() => setShowPopup(true)}
            />
          )}

          {hasContactAnchor && (
            <ActionButton
              iconName="https://site-lms.fra1.digitaloceanspaces.com/Mail_46bac8fc9f.svg"
              label="Être contacté"
              href="#contact"
              className="mt-[-20px]"
            />
          )}

          <ActionButton
            iconName="https://site-lms.fra1.digitaloceanspaces.com/Mall_5f93dab076.svg"
            label="Commander"
            target="_blank"
            href={commanderHref}
            className="mt-[-20px]"
          />
        </div>
      </div>

      {showPopup && <CallPopup onClose={() => setShowPopup(false)} />}
    </>
  );
}